import {
  SET_CONFIGURATIONS,
  SET_LOADED_CONFIGURATION,
  REMOVE_CONFIGURATION,
  CLEAR_LOADED_CONFIGURATION,
  SET_SAVING,
} from './types';

export const setConfigurations = payload => ({
  type: SET_CONFIGURATIONS,
  payload,
});

export const setLoadedConfiguration = payload => ({
  type: SET_LOADED_CONFIGURATION,
  payload,
});

export const removeConfiguration = payload => ({
  type: REMOVE_CONFIGURATION,
  payload,
});

export const clearLoadedConfiguration = () => ({
  type: CLEAR_LOADED_CONFIGURATION,
});

export const setSaving = payload => ({
  type: SET_SAVING,
  payload,
});
